

// object to store loaded CSS chunks
var installedCssChunks = {
	818: 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"381":1,"715":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "static/css/" + ({"7":"pages-page-about","33":"components-Sponsors","76":"pages-page-auth-success","86":"pages-page-live","132":"pages-page-balance","133":"pages-page-promotion-and-bonuses","177":"pages-page-statistics","210":"pages-page-calendar","233":"pages-page-games-cyberbet-ui","234":"widgets-live-match-tracker","301":"pages-page-casino","308":"pages-results","311":"pages-page-main","333":"pages-page-favourite-events","361":"components-Banners","363":"pages-page-promotion","365":"pages-page-notification","371":"pages-page-games-bet","380":"SponsorsHighResolution","388":"pages-page-bets-history","482":"pages-page-games-turbo","504":"pages-page-games-live","604":"pages-page-terms-and-conditions","615":"pages-page-policy-aml","651":"pages-page-frigg","656":"pages-page-event","684":"pages-page-search","715":"widgets-live-match-broadcast","764":"pages-page-auth-success-sign-up","797":"pages-page-games-vsport-ui","843":"pages-page-head-to-head","850":"pages-search-tournament","855":"pages-page-profile","968":"pages-page-404"}[chunkId]||chunkId) + "." + {"7":"31d6cfe0","33":"31d6cfe0","76":"31d6cfe0","86":"31d6cfe0","132":"31d6cfe0","133":"31d6cfe0","177":"31d6cfe0","210":"31d6cfe0","233":"31d6cfe0","234":"31d6cfe0","301":"31d6cfe0","308":"31d6cfe0","311":"31d6cfe0","333":"31d6cfe0","361":"31d6cfe0","363":"31d6cfe0","365":"31d6cfe0","371":"31d6cfe0","380":"31d6cfe0","381":"8d5034af","388":"31d6cfe0","482":"31d6cfe0","504":"31d6cfe0","604":"31d6cfe0","615":"31d6cfe0","651":"31d6cfe0","656":"31d6cfe0","684":"31d6cfe0","715":"858e5c89","764":"31d6cfe0","797":"31d6cfe0","843":"31d6cfe0","850":"31d6cfe0","855":"31d6cfe0","968":"31d6cfe0"}[chunkId] + ".chunk.css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.code = "CSS_CHUNK_LOAD_FAILED";
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;

			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};